.span {
  background: var(--paper-2);
  color: var(--ink);
  border-radius: var(--radius-s);
  padding: 0 0.15em;
}

.evidence {
  font-size: var(--text-min-body, 0.875rem);
  color: var(--muted);
  margin: 0.15rem 0 0;
}

.byOperator {
  color: var(--ink-soft);
}

/*
 * `LGH-036`. The trust-weight label ahead of every evidence sentence.
 * `data-shared` marks the one class evidenced by OTHER tenants' history
 * (`sharedSuggestion`) — distinct styling, not just distinct wording, per
 * `SPEC-CPM-001 §8`'s own argument that a merged presentation misstates
 * confidence.
 */
.evidenceClass {
  display: inline-block;
  font-size: var(--text-min-mono, 0.75rem);
  letter-spacing: 0.02em;
  color: var(--ink-soft);
  background: var(--paper-2);
  border-radius: var(--radius-s);
  padding: 0 0.35em;
}

.evidenceClass[data-shared='true'] {
  color: var(--warn);
  background: transparent;
  border: 1px solid currentColor;
}

/* `LGH-018` §1. The instant a catalogue value was actually read — a fact about a moment, not a standing truth. */
.readAt {
  color: var(--ink-soft);
}
